import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';

import { ToastService } from '../components/toast/toast.service';
import { AuthService } from './auth.service';

/** Texto do aviso quando o Admin visualiza uma conta com RCS mas não tem RCS na conta dele. */
export const RCS_SIMULATION_BLOCKED =
  'As telas do RCS não abrem em "Visualizar conta": o servidor confere o RCS da sua conta de administrador, '
  + 'não o da conta visualizada. Para conferir o RCS deste cliente, entre com a conta dele ou ligue o RCS na sua.';

/**
 * Telas do RCS só para quem tem `rcs_enabled` na conta (molde do `AiEnabledGuard`).
 * A API aplica o mesmo corte no middleware `rcs.enabled`; aqui é para não abrir
 * uma tela que só responderia 403.
 *
 * Visualizando outra conta (`simulate`), o middleware olha o ADMIN, não o cliente
 * (igual ao `ai.enabled`, QA API 01/10). Sem a flag no admin toda tela RCS abria com
 * "Não foi possível carregar": agora a tela nem abre e o motivo aparece.
 */
@Injectable({ providedIn: 'root' })
export class RcsEnabledGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router, private toastService: ToastService) {}

  canActivate(): boolean | UrlTree {
    const user = this.authService.getUser();
    if (!user?.rcs_enabled) {
      return this.router.parseUrl('/dashboard');
    }

    if (this.authService.isSimulating && !this.authService.getLoggedInUser()?.rcs_enabled) {
      this.toastService.warning(RCS_SIMULATION_BLOCKED, 9000);
      return this.router.parseUrl('/dashboard');
    }

    return true;
  }

  canActivateChild(): boolean | UrlTree {
    return this.canActivate();
  }
}
